import { Component } from '@angular/core';

@Component({
  selector: 'app-layout-results',
  templateUrl: './layout-results.component.html',
  styleUrls: ['./layout-results.component.scss']
})
export class LayoutResultsComponent {}
